import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.tsx'
import { TourProvider } from './components/tour/TourProvider'
import { initSentry } from './lib/sentry.ts'

// Sentry初期化（VITE_SENTRY_DSN未設定時はスキップ）
initSentry()

// 開発環境では既存のService Workerを解除（古いキャッシュによる白画面を防止）
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
      console.log('Dev mode: Service Worker unregistered');
    });
  });
}

// React Query クライアント設定
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 1000, // 10秒
      refetchOnWindowFocus: true,
      retry: 2,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TourProvider>
        <App />
      </TourProvider>
    </QueryClientProvider>
  </StrictMode>,
)
